var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"button","size":"sm","variant":"success","disabled":_vm.disabled},on:{"click":_vm.resetPassword}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Reset\n")])}
var staticRenderFns = []

export { render, staticRenderFns }